module.exports = __webpack_public_path__ + "img/icon_checklist_white.c422994d.svg";